import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {getAllOrders} from "../../../redux/actions/orders";
import SEARCH from "../../../assets/images/search.svg"

const FilterOrdersComponentMobile = (props) => {
    console.log(props);
    const {search, page, perPage} = props;
    const dispatch = useDispatch();
    const [query, setQuery] = useState(search);
    useEffect(() => {
        let time = setTimeout(() => {
            dispatch(getAllOrders({
                page : page,
                perPage: perPage,
                query : query
            }));
        },1000);
        return () => clearTimeout(time);
    },[dispatch, query]);
    return (
        <>
            <div className="shadow-sm rounded filter-orders-holder-mobile">
                <div className="form-group row">
                    {/* <label htmlFor="username" className="col-lg-2 col-form-label text-md-right">جستجو با نام و موبایل مشتری یا کد سفارش :</label> */}
                    <div className="col-lg-3 no-padding">
                        <input id="username" type="text"
                               className="form-control"
                               name="search"
                               placeholder="جستجو با نام و موبایل مشتری یا کد سفارش :"
                               autoFocus={true}
                               value={query}
                               onChange={(search) => {
                                   search = search.target.value;
                                   setQuery(search);
                               }}
                               autoComplete="search"
                        />
                        <img src={SEARCH} className="search-icon"></img>
                    </div>
                </div>
            </div>
        </>
    )
};

export default FilterOrdersComponentMobile;
